@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: container from "../../styles/composable/layout.module.css";
    display: flex;

    @media ($below-mobile) {
        flex-direction: column;
    }
}

.flippedRoot {
    composes: root;

    @media ($above-mobile) {
        flex-direction: row-reverse;
    }
}

.column {
    flex: 0 0 50%;
}

.contentColumn {
    composes: column;
    composes: dark from "../../styles/theming.module.css";
    position: relative;
}

.mediaColumn {
    composes: column;
}

.media {
    display: block;
    width: 100%;
    aspect-ratio: 1;
    overflow: hidden;

    > :is(img, video) {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.contentWrapper {
    position: absolute;
    inset: 0;
    background-color: rgb(var(--true-black-base) / 45%);
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.content {
    padding: var(--spacer-40);
    text-align: center;
}
